<template>
  <div class="game-controls__rounds">
    <div class="game-controls__rounds--actual">{{ turn }}</div>
    <div class="game-controls__rounds--total">
      of {{ maxTurn }} <br />rounds
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Rounds",
  computed: {
    ...mapGetters(["activeGame"]),
    turn() {
      return _.get(this.activeGame, "turn", "-");
    },
    maxTurn() {
      return _.get(this.activeGame, "maxTurn", "-");
    },
  },
};
</script>
